import { cn } from "../../lib/utils";

export default function RadioButton({ checked }: { checked: boolean }) {
  return (
    <div
      className={cn(
        "w-4 h-4 rounded-full border border-border bg-primary/20",
        checked && "bg-accent border-primary border-1"
      )}
    />
  );
}
